<template>
  <div class="flex align-items-start cursor-pointer">
    <el-checkbox
      :fill="bg.c_border"
      style="max-width:22px !important"
      v-model="checkedPay"
      @change="handleChange"
      class="mr-10 radio-check-policy "
    />
    <p v-if="typeTitle" class=" m-0 c-black-text lh-20 c-medium-text">
      {{ $t("enterBook") }}

      <span
        @click="handleRedirect('/policy/user-info-security')"
        style="text-decoration:underline;"
        class="text-link"
        >{{ $t("cusInfoSecurityPolicy") }}</span
      >
    </p>
    <p v-else class=" m-0 c-black-text lh-20 c-medium-text">
      {{ $t("enterPay") }}
      <span
        @click="handleRedirect('/policy/terms-transaction')"
        style="text-decoration:underline;"
        class="text-link"
        >{{ $t("termsTransaction") }}</span
      >
      {{ $t("and") }}
      <span
        @click="handleRedirect('/policy/user-info-security')"
        style="text-decoration:underline;"
        class="text-link"
        >{{ $t("personalInformationPolicy") }}</span
      >
      {{ $t("out") }}
    </p>
  </div>
</template>
<script>
import { getBackGround } from "../../utils/wapAuth";

export default {
  name: "checkbox",
  props: {
    checked: {
      default: true
    },
    typeTitle: {
      default: null
    }
  },
  data() {
    return {
      checkedPay: true,
      bg: getBackGround()
    };
  },
  methods: {
    handleChange(val) {
      this.$emit("on-action", val);
    },
    handleRedirect(url) {
      window.open(url, "_blank");
    }
  }
};
</script>
<style>
.radio-check-policy .el-checkbox__input.is-checked .el-checkbox__inner {
  width: 18px !important;
  height: 18px !important;
  background: v-bind("bg.c_border") !important;
  border: 2px solid v-bind("bg.c_border") !important;
}
.radio-check-policy .el-checkbox__input .el-checkbox__inner {
  width: 18px !important;
  height: 18px !important;
  border: 1.1px solid v-bind("bg.c_border") !important;
  border-radius: 3px;
}
.radio-check-policy .el-checkbox__input .el-checkbox__inner::after {
  box-sizing: content-box;
  content: "";
  border: 1px solid;
  border-color: #ffff !important;
  border-left: 0;
  border-top: 0;
  height: 7px;
  left: 5px;
  position: absolute;
  top: 2px;
  width: 3px;
}
</style>
<style scoped>
.text-link {
  color: v-bind("bg.c_inherit_text");
  font-weight: 600;
}
</style>
